/* @ngInject */
const resizeId = ($window) => {
  const resizeToFitId = (element) => {
    const divHeight = element.width() / 2.16
    const height = divHeight * 0.19
    element.css('fontSize', height / 1.6)

    const onWindowResize = () => {
      const divHeight = element.width() / 2.16
      const height = divHeight * 0.19
      element.css('fontSize', height / 1.6)
    }

    $window.addEventListener('resize', onWindowResize)
  }

  return {
    restrict: 'AE',
    link: (scope, element) => {
      resizeToFitId(element)

      scope.$on('$destroy', () => {
        element.off()
        $window.removeEventListener('resize', onWindowResize)
      })
    },
  }
}

export default resizeId



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/styles/resizeId.js